import React, { FC } from 'react'

import { Button, ButtonVariants } from '@inno-ui/button'
import cn from 'clsx'
import { useTranslation } from 'react-i18next'

import { TourNavigationButton } from '../../TourNavigationButton'
import styles from './Homepage.module.scss'
import { HomepageProps } from './Homepage.types'
import ClusterixLogo from '/public/clusterix-logo.svg'

export const Homepage: FC<HomepageProps> = ({ setActivePage, skipTour }) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'product_tour.homepage'
  })

  const isPersonal = true // TODO: make this dynamic

  return (
    <div
      className={cn(styles.homepage, {
        [styles.personal]: isPersonal,
        [styles.organization]: !isPersonal
      })}
    >
      <div className={styles.content}>
        <div className={styles.welcome}>
          <span>{t('welcome_to')}</span>
          <img src={ClusterixLogo} alt='Clusterix Logo' />
        </div>
        <div className={styles.texts}>
          <span className={styles.title}>
            {t(isPersonal ? 'title_personal' : 'title_organization')}
          </span>
          <p>
            {t(
              isPersonal ? 'description_personal' : 'description_organization'
            )}
          </p>
        </div>
      </div>
      <div className={styles.navigation}>
        <TourNavigationButton
          label={t('navigate')}
          onClick={() => setActivePage('interconnected-apps')}
        />
        <Button
          variant={ButtonVariants.Ghost}
          label={t('skip_tour')}
          onClick={skipTour}
        />
        <span className={styles.takeTourAgainReminder}>
          {t('take_tour_again_reminder')}
        </span>
      </div>
    </div>
  )
}
